import React from "react";
import {
  FiUploadCloud,
  FiSliders,
  FiCheckCircle,
  FiDownloadCloud,
  FiArrowRight,
} from "react-icons/fi";

const steps = [
  {
    icon: <FiUploadCloud />,
    title: "Upload",
    desc: "Upload your RAW files via our portal",
  },
  {
    icon: <FiSliders />,
    title: "We Edit",
    desc: "We edit and retouch in your style",
  },
  {
    icon: <FiCheckCircle />,
    title: "Quality Check",
    desc: "We double check every image for perfection",
  },
  {
    icon: <FiDownloadCloud />,
    title: "Download",
    desc: "Receive your final gallery within 24-48 hrs",
  },
];

const WorkflowSection = () => {
  return (
    <section className="workflow-section">
      <h2 className="workflow-heading">Our Simple 4-Step Workflow</h2>

      <div className="workflow-content">
        <div className="workflow-steps">
          {steps.map((step, index) => (
            <React.Fragment key={step.title}>
              <div className="workflow-step">
                <div className="workflow-step-number">{index + 1}</div>
                <div className="workflow-step-icon">{step.icon}</div>
                <div className="workflow-step-title">{step.title}</div>
                <div className="workflow-step-desc">{step.desc}</div>
              </div>
              {index < steps.length - 1 && (
                <div className="workflow-connector">
                  <FiArrowRight />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="workflow-cta-card">
          <h3 className="workflow-cta-title">
            Get 10 Photos
            <br />
            <span>Edited for FREE</span>
          </h3>
          <p className="workflow-cta-desc">
            Send us 10 RAW photos and we'll edit them in your style. No
            commitment!
          </p>
          <button className="workflow-cta-btn">Upload Your Sample</button>
        </div>
      </div>
    </section>
  );
};

export default WorkflowSection;
